import { render, staticRenderFns } from "./changeData.vue?vue&type=template&id=bbdd4cfe"
import script from "./changeData.vue?vue&type=script&lang=js"
export * from "./changeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports